import React from "react";
import ReactGA from "react-ga4";
import LogoSelector from "./LogoSelector";
import { MultiLevelSelector } from "../MultiLevelSelector";
import { useMakes } from "../../../routes/Configuration/hooks";
import { CategoryName, DataSource } from "../../../models/enums";
import styles from "./style.scss";

// limit to 6 for now, following the design.
const MaximumNumberOfLogos = 6;

const gaLabelForMakes = (category: string) => {
  if (category === CategoryName.car) return "Top marke u autima";
  if (category === CategoryName.motorbike) return "Top marke u motorima";
  return "Top marke u autobusima";
};

// Make/model picker with the popular make logos on top. The logo tiles only
// exist for the make datasource; makes are fetched for the control's category.
const MultiLevelSelectorWithLogo = props => {
  const {
    value,
    child,
    dataSource,
    category,
    logoTitle,
    changeForbidden,
    hidePopulars = false
  } = props;

  const makes = useMakes(dataSource === DataSource.make ? category : undefined);

  const handleValueChange = selectedValue => {
    const { onError, child } = props;

    const selectedMake = selectedValue && makes
      ? makes.find(c => c.id === selectedValue)
      : undefined;

    // Track GA for popular make selection via logo tile
    if (selectedMake && selectedMake.popular) {
      const gaLabel = gaLabelForMakes(category);
      ReactGA.event({
        category: "Odabir marke",
        action: "Click",
        label: gaLabel
      });
    }

    // The model is required only when the chosen make has models to choose from
    const hasModels = selectedMake && selectedMake.models && selectedMake.models.length > 0;
    onError(hasModels ? "Odaberite sve razine" : undefined);
    props.onChange({ [child.field]: selectedValue });
  };

  const haveLogoOptions = (makes || [])
    .filter(o => o.logoId)
    .map(c => ({
      title: c.name,
      value: c.id,
      logoId: c.logoId,
      logoOrder: c.logoOrder
    }));
  haveLogoOptions.sort((x, y) => x.logoOrder - y.logoOrder);

  // The ad form classes (selector margins) apply to every datasource, locations included;
  // only the logo tiles depend on the makes being loaded.
  return (
    <React.Fragment>
      {!hidePopulars && haveLogoOptions.length >= 3 && logoTitle ? (
        <React.Fragment>
          <LogoSelector
            value={value ? value[child.field] : null}
            onChange={handleValueChange}
            options={haveLogoOptions.slice(0, MaximumNumberOfLogos)}
            title={logoTitle}
            changeForbidden={changeForbidden}
          />
          <hr className={styles.divider} />
        </React.Fragment>
      ) : null}
      <MultiLevelSelector {...props} className={styles.adFormWrapper} selectorClassName={styles.adFormSelector} excludeFilterOnly />
    </React.Fragment>
  );
};

MultiLevelSelectorWithLogo.defaultProps = {
  value: null
};

export default MultiLevelSelectorWithLogo;



// WEBPACK FOOTER //
// ./src/components/FormControls/MultiLevelSelectorWithLogo/index.tsx